import { Conditional, Else, Grid, Heading, If, Paragraph, Row } from "@hex-insights/core";
import { useActivePageRegistration, useHistory } from "@hex-insights/router";
import {
	ButtonLink,
	GuardianComponents,
	useReEnrollmentGuardiansOverviewQuery,
} from "@hex-insights/verita-romania.shared";
import { ReEnrollmentLayout } from "../../Components";
import { reEnrollmentStudentHealthPageInfo } from "../../StudentHealthPage/pageinfo";
import { getReEnrollmentStudentFilter } from "../../Utilities";
import { reEnrollmentGuardiansDetailPageInfo } from "../DetailPage/pageinfo";
import { reEnrollmentGuardiansIndexPageInfo } from "./pageinfo";
import generalStyles from "../../general.module.css";

const responsiveGridTracks = {
	0: 1,
	700: 2,
};

export function ReEnrollmentGuardiansIndexPage() {
	useActivePageRegistration(reEnrollmentGuardiansIndexPageInfo);

	const { loading, data } = useReEnrollmentGuardiansOverviewQuery({
		variables: {
			filters: {
				relationships: [
					{
						student: [getReEnrollmentStudentFilter()],
					},
				],
			},
		},
	});

	const history = useHistory();

	return (
		<ReEnrollmentLayout
			footerContent={
				<Row justify="flex-end">
					<ButtonLink variant="primary" to={reEnrollmentStudentHealthPageInfo.to}>
						Looks Good, Continue
					</ButtonLink>
				</Row>
			}
		>
			<Heading.H1 className={generalStyles["heading"]}>
				These are the guardians we have on file for your students. Is this information still accurate?
			</Heading.H1>

			<Paragraph>
				If any information has changed, <strong>please edit the relevant guardian's information</strong>.
			</Paragraph>

			<Conditional>
				<If condition={loading && !data}>
					<span>Loading...</span>
				</If>
				<Else>
					<Grid responsiveTracks={responsiveGridTracks} gap="1.5rem">
						{data?.guardianConnection.edges.map(({ node }) => (
							<GuardianComponents.GuardianContactInformationReviewCard
								key={node.id}
								guardian={node}
								onEditClick={() => history.push(reEnrollmentGuardiansDetailPageInfo.to(node.id))}
							/>
						))}
					</Grid>
				</Else>
			</Conditional>
		</ReEnrollmentLayout>
	);
}
